import {defineAsyncComponent} from 'vue'
const PlatformOperateRouter = [
  {
    path: 'banner',
    name: 'Banner',
    component: () => import('@/views/PlatformOperate/Banner/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'popups',
    name: 'Popups',
    component: () => import('@/views/PlatformOperate/Popups/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'activitys',
    name: 'Activitys',
    component: () => import('@/views/PlatformOperate/Activitys/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'platforms',
    name: 'Platforms',
    component: () => import('@/views/PlatformOperate/Platforms/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'platform_config',
    name: 'PlatformIndexConfig',
    component: () => import('@/views/PlatformOperate/Platforms/PlatformIndexConfig.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'members',
    name: 'Members',
    component: () => import('@/views/PlatformOperate/Members/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'invitations',
    name: 'Invitations',
    component: () => import('@/views/PlatformOperate/Invitations/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'baidu',
    name: 'Baidu',
    component: () => import('@/views/PlatformOperate/Baidu/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'equity',
    name: 'Equity',
    component: () => import('@/views/PlatformOperate/Equity/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
  {
    path: 'uk',
    name: 'UK',
    component: () => import('@/views/PlatformOperate/UK/Index.vue'),
    meta: {
      key: 'platformOperate'
    },
  },
]
export {PlatformOperateRouter}
